var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.997,
    height: 26,
    viewBox: "0 0 25.997 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7009",
    "data-name": "Caminho 7009",
    d: "M26.165,13.166a4.333,4.333,0,1,0-4.3-3.8L11.842,14.379a4.333,4.333,0,1,0,0,6.239L21.866,25.63a4.333,4.333,0,1,0,1.293-2.583L13.135,18.034a4.376,4.376,0,0,0,0-1.069l10.024-5.012A4.311,4.311,0,0,0,26.165,13.166Z",
    transform: "translate(-4.502 -4.5)",
    fill: "#1abfd5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShare);
export default __webpack_public_path__ + "static/media/new_share.3894899082d35c76203866063b348a03.svg";
export { ForwardRef as ReactComponent };